<template>
  <div id="">
    <div class="bottom">
      <div class="us row">
        <!-- <div class="us"> -->
        <div class="col-md-4">
          <!-- <div> -->
          <div>
            <div class="titleText">关于墨客云</div>
            <div>{{ footerData.desc }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <!-- <div> -->
          <div>
            <div class="titleText">联系我们</div>
            <div>
              <div>
                <span>联系电话:</span>
                <span>{{ footerData.mobile }}</span>
              </div>
              <div>
                <span>研发中心:</span>
                <span>南京市江宁区格致路100号1号楼6层</span>
              </div>
              <div>
                <span>联系地址:</span>
                <span>{{ footerData.address }}</span>
              </div>
              <div>
                <span>业务 QQ:</span>
                <span>{{ footerData.QQ }}</span>
              </div>
              <div>
                <span>服务邮箱:</span>
                <span>bd@mokyun.com</span>
              </div>
              <!-- <div>
                <span>对公账号:</span>
                <span>{{ footerData.account }}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <!-- <div> -->
          <div>
            <div class="titleText last-one" style="    text-align: left;">
              友情链接
            </div>
            <div>
              <div
                v-for="(item, index) in footerData.friendLink"
                class="link"
                style="display: flex;flex-direction: column;align-items: flex-start;"
              >
                <a
                  :href="item.link_url"
                  title="南京微信小程序开发"
                  alt="南京小程序开发"
                  style="color: #cdcdcd;text-decoration:none;"
                  >{{ item.link_name }}</a
                >
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <!-- <div> -->
          <div>
            <div class="titleText">关注我们</div>
            <div class="concern-code">
              <img
                src="../assets/code.jpg"
                class="codeImg"
                @mouseover="codeOver($event)"
                @mouseout="codeOut($event)"
                style="cursor: pointer;"
              />
              <img src="../assets/phone.png" class="seePhone" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer>
      <div class="footer">
        <div class="top">
          Copyright ©2014-{{ year }} MokYun
          <span style="cursor: pointer;font-weight:bolder" @click="loginMokyun"
            >墨客云小程序开放平台</span
          >
        </div>
        <div class="top">
          <a href="https://beian.miit.gov.cn/">苏ICP备{{ footerData.ICP }}号 </a
          >南京薄幕软件科技有限公司版权所有 Powered by MokYun
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import getData from '../api/getInfo';
export default {
  data() {
    return {
      year: 0,
      footerData: {},
    };
  },
  created() {
    this.getDay();
    this.getFooter();
    // this.friendLink();
  },
  mounted() {},
  methods: {
    codeOver() {
      $('.seePhone').css({ opacity: '1' });
    },
    codeOut() {
      $('.seePhone').css({ opacity: '0' });
    },
    getDay() {
      let year = new Date().getFullYear();
      this.year = year;
    },
    putOnRecord() {
      window.open('https://beian.miit.gov.cn/');
    },
    // 获取底部信息
    getFooter() {
      // getData
      //   .getFooter()
      //   .then((res) => {
      let info = {
        id: '1',
        desc:
          '墨客云科技（MokYun）是南京薄幕软件科技有限公司旗下的一家提供小程序产品研发、设计、运营的一站式服务商，同时对外提供高效的Serverless云函数服务，平台致力于为企业的微创新从创意萌芽、产品实现、成长发展提供全面的服务和支持。',
        mobile: '180-129-01065',
        tel: '025-5760-3388',
        address: '南京市江宁区未来科技城佳强大厦9层',
        QQ: '534783032',
        // account: '民生银行江宁支行 6232550800270432',
        ICP: '16028042',
        appid: '23',
      };
      let friend = [
        {
          id: '1',
          link_name: '阿里云',
          link_url: 'https://www.aliyun.com',
          sort: '10',
          appid: '23',
        },
        {
          id: '3',
          link_name: '七牛云',
          link_url: 'https://www.qiniu.com/',
          sort: '9',
          appid: '23',
        },
        {
          id: '4',
          link_name: '墨客云盒',
          link_url: 'http://mobox.mokyun.com',
          sort: '4',
          appid: '23',
        },
        {
          id: '2',
          link_name: '微信小程序',
          link_url: 'https://mp.weixin.qq.com',
          sort: '3',
          appid: '23',
        },
        {
          id: '5',
          link_name: '南京小程序开发',
          link_url: 'https://ww.mokyun.com',
          sort: '0',
          appid: '23',
        },
      ];
      let tempData = info;
      // this.footerData = res.data
      // this.friendLink().then((res) => {
      tempData.friendLink = friend;
      this.footerData = tempData;
      // console.log(this.footerData)
      // });
      // })
      // .catch((e) => {});
    },

    // 获取友情链接
    // friendLink() {
    //   return new Promise((resolve, reject) => {
    //     getData
    //       .friendLink()
    //       .then((res) => {
    //         resolve(res.data);
    //       })
    //       .catch((e) => {
    //         reject(e);
    //       });
    //   });
    // },
    // 登录墨客云开放平台
    loginMokyun() {
      window.open('https://open.mokyun.com/login');
    },
  },
};
</script>

<style>
.bottom {
  width: 100%;
  background: #343434;
  color: white;
}
.bottom .us {
  width: 80%;
  margin: 0 auto;
  padding: 4.5em 0 4.5em 3.2em;
  padding-left: 3.2em;
}
@media (max-width: 360px) {
  .bottom .us {
    padding: 1.5em 0 1.5em 3.2em;
  }
}
/* .us>div{
	width: 25%;
	background: black;
	margin-left: 5px;
} */

.bottom .us .col-md-3 .codeImg {
  width: 50%;
}
.bottom .us .col-md-3 .titleText {
  /* margin-left: 15px; */
}
.bottom .us .col-md-4 > div {
  padding-right: 4px !important;
}
@media only screen and (max-width: 1550px) and (min-width: 992px) {
  .bottom .us .col-md-3 .codeImg {
    width: 50%;
  }
  .bottom .us .col-md-3 .titleText {
    margin-left: 0;
  }
}
.bottom .us .seePhone {
  width: 50%;
  transition: all 0.5s ease-in-out;
  opacity: 0;
}
@media (max-width: 992px) {
  .bottom .us {
    width: 100%;
    margin: 0 auto;
    padding: 4.5em 0 4.5em 3.2em;
    padding-left: 3.2em;
  }
  .bottom .us .last-one {
    text-align: left;
  }
  .us .col-md-2 .link {
    text-align: left !important;
  }
  /* .bottom .us > div {
    width: 35%;
  } */
  .bottom .us .col-md-3 .codeImg {
    width: 15%;
  }
  .bottom .us .last-one {
    text-align: left !important;
  }
  .bottom .us .seePhone {
    width: 15%;
    transition: all 0.5s ease-in-out;
    opacity: 0;
  }
  .bottom .us .col-md-3 .titleText {
    margin-left: 0;
  }
}
@media (max-width: 768px) {
  .bottom .us {
    width: 100%;
    margin: 0 auto;
    padding: 4.5em 1.2em 4.5em 1em;
    padding-left: 3.2em;
    flex-direction: column;
  }
  /* .bottom .us {
  } */
  /* .bottom .us > div {
    width: 40%;
  } */
  .bottom .us .col-md-3 .codeImg {
    width: 20%;
  }
  .bottom .us .col-md-3 .titleText {
    margin-left: 0;
  }

  .bottom .us .seePhone {
    width: 20%;
    transition: all 0.5s ease-in-out;
    opacity: 0;
  }
}
@media (max-width: 450px) {
  .bottom .us {
    width: 100%;
    margin: 0 auto;
    padding: 4.5em 0.5em 4.5em 1.2em;
    /* padding-left: 3.2em; */
    flex-direction: column;
  }
  /* .bottom .us > div {
    width: 90%;
  } */
  .bottom .us .col-md-3 .codeImg {
    width: 30%;
  }
  .bottom .us .col-md-3 .titleText {
    margin-left: 0;
  }

  .bottom .us .seePhone {
    width: 30%;
    transition: all 0.5s ease-in-out;
    opacity: 0;
  }
}
.bottom .us > div {
  margin-bottom: 2em;
}
.col-md-3 > div {
  /* width: 80%; */
  margin: 0 auto;
  /* padding-left: 20px; */
}
.bottom .us .concern-code {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}
@media (max-width: 1550px) {
  .bottom .us .concern-code {
    justify-content: flex-start;
  }
  .bottom .us .col-md-3 .titleText {
    margin-left: 0;
  }
}

.bottom .us .titleText {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: rgba(255, 255, 255, 0.9);
  opacity: 0.9;
  margin-bottom: 0.9em;
}

.bottom .us .last-one {
  text-align: center;
}

.bottom .us > div > div > div:nth-child(2) {
  font-family: MicrosoftYaHei;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #cdcdcd;
}

.us .col-md-2 .link {
  text-align: center;
}

.footer {
  width: 100%;
  min-height: 85px;
  background: #222;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 15px 15px;
  color: #e1e1e1;
  font-family: 'microsoft yahei';
  font-size: 13px;
  line-height: 24px;
}

/* footer > div {
  width: 90%;
  font-family: 'microsoft yahei';
  font-size: 14px;
  line-height: 24px;
  color: #e1e1e1;
  text-align: center !important;
} */
</style>



// WEBPACK FOOTER //
// src/view/footer.vue